// @flow

import { loadStripe } from '@stripe/stripe-js'
import { isServer, envConfig } from '../env'

let stripePromise: ?Promise<any>

export function stripe (): Promise<any> | null {
  if (isServer) {
    return null
  }

  if (!stripePromise) {
    const stripeKey = envConfig().STRIPE_KEY
    if (!stripeKey) {
      console.warn('Stripe key not found in environment variables')
      return null
    }

    // Add error handling for network and cross-origin issues
    stripePromise = loadStripe(stripeKey).catch((error: Error): null => {
      console.warn('Failed to load Stripe.js:', error.message)
      // Reset promise to allow retry on next call
      stripePromise = null
      return null
    })
  }

  return stripePromise
}
